// extracted by mini-css-extract-plugin
export default {"groove":"toggler_groove__OAy4E","slider":"toggler_slider__67udn","toggle_on":"toggler_toggle_on__f3IPB","groove_toggle_on":"toggler_groove_toggle_on__f4Lrs"};